module.exports = __webpack_public_path__ + "static/BT1-desert-1a26762b10e42f3dfee5a721639947e0.png";